import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { ChatComponent } from './chat.component';
import { AuthGuardService } from 'src/app/guards/auth-guard.service';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.chat.pageInRouting,
    data: { data: PAGES_AND_PATHS.chat },
    component: ChatComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./chat.module').then(m => m.ChatModule)
  },
  {
    path: PAGES_AND_PATHS.chatSingleConversation.pageInRouting,
    data: { data: PAGES_AND_PATHS.chatSingleConversation },
    component: ChatComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./chat.module').then(m => m.ChatModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChatRoutingModule { }
